module.exports = __webpack_public_path__ + "img/bg_3.8c8df806.png";